import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BriefcaseIcon from '@mui/icons-material/BusinessCenter';
import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function UserInfo({ children, isBusiness }) {
  return (
    <Stack
      alignItems="center"
      gap={1.5}
      horizontal
      sx={(theme) => ({
        color: theme.palette.fixed.white,
        flexGrow: 1
      })}
    >
      {isBusiness ? <BriefcaseIcon /> : <AccountCircleIcon />}
      <Text component="span" size="sm" sx={{ width: 120 }} truncate>
        {children}
      </Text>
    </Stack>
  );
}

UserInfo.propTypes = {
  children: PropTypes.node.isRequired,
  isBusiness: PropTypes.bool
};

export default UserInfo;
